module.exports = {"540502100":"泽当镇","540502101":"昌珠镇","540502200":"颇章乡","540502201":"结巴乡","540502202":"多颇章乡","540502203":"索珠乡","540502204":"亚堆乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540502.json
// module id = 2527
// module chunks = 0